import React, { Fragment } from 'react';
import Button from '@cmsgov/design-system-core/dist/components/Button/Button';
import { FormattedMessage } from 'react-intl/dist';

// Components

import ModalHeader from '../../common/headers/ModalHeader';




const InformLawfullyPresenceRequiredForCoverageModal = props => {

    const {
        actions: {
            hideAllModals
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        modal: {
            modalData: {
                callbacks
            }
        },
        modalHeaderProps
    } = props;

    const handleHideClick = () => hideAllModals();

    const handleRightBtnClick = () => {
        callbacks.map(callback => {
            callback();
        });
        handleHideClick();
    };

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader
                    {...{
                        ...modalHeaderProps,
                        hideModal: hideAllModals
                    }}
                    closeAllModals
                    hideAllModals={hideAllModals}
                />
            </div>
            <div className="gi-modal__body txt-left" id = 'informLawfullyPresenceRequiredForCoverageModal' >
                <FormattedMessage
                    id='modals.lawful_presence.notice'
                    tagName='p'
                />
            </div>
            <div className='gi-modal__controls'>
                <Button
                    className='usa-button usa-button--outline gi-button gi-button__outline'
                    onClick={handleHideClick}
                >
                    <FormattedMessage id='button.close'/>
                </Button>
                <Button
                    className='usa-button gi-button gi-button__primary'
                    onClick={handleRightBtnClick}
                    inputRef={boundAnchor(anchor_1)}
                >
                    <FormattedMessage id='button.ok'/>
                </Button>
            </div>
        </Fragment>
    );
};

export default InformLawfullyPresenceRequiredForCoverageModal;
